import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  missingSection: {
    id: 'frontbucket.pipelines.components.warningMessage.missingSection',
    description:
      'Text for missing section. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'The {parentElement} section in your <bold>{ymlFileName}</bold> file is missing a {element}. Add the missing {element} to get this working.',
  },
  missingString: {
    id: 'frontbucket.pipelines.components.warningMessage.missingString',
    description:
      'Text for missing string specific. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'The {element} in the {parentElement} section of your <bold>{ymlFileName}</bold> file is missing a string. Add the missing string to to get this working.',
  },
  pipelineErrorText: {
    id: 'frontbucket.pipelines.components.warningMessage.pipelineErrorText',
    description: 'Pipeline error text',
    defaultMessage: 'Unable to retrieve Pipeline.',
  },
  memoryLimit: {
    id: 'frontbucket.pipelines.components.warningMessage.memoryLimit',
    description: 'Text for memory limit',
    defaultMessage: 'memory limit',
  },

  improvedErrorMappingEnabledText: {
    id: 'frontbucket.pipelines.components.warningMessage.improvedErrorMappingEnabledText',
    description:
      'Text for improved error mapping enabled. The "supported by your plan" link text is wrapped in <linkOne> tags. The "contains too many parallel steps" link text is wrapped in <linkTwo> tags.',
    defaultMessage:
      "You''ve exceeded the maximum number of concurrent steps <linkOne>supported by your plan</linkOne>. Any steps in excess of this limit have failed. This may indicate you''re running too many pipelines at once, or pipeline <linkTwo>contains too many parallel steps</linkTwo>.",
  },
  improvedErrorMappingDisabledText: {
    id: 'frontbucket.pipelines.components.warningMessage.improvedErrorMappingDisabledText',
    description: 'Text for improved error mapping disabled',
    defaultMessage:
      "Seems like you're running a lot of pipelines at the same time. This is usually due to an accidental push. To conserve your minutes, we won't run them all.",
  },
  troubleShootingSteps: {
    id: 'frontbucket.pipelines.components.warningMessage.troubleShootingSteps',
    description: 'Text for trouble shooting steps',
    defaultMessage: 'Troubleshooting Steps',
  },
  timeLimitExceeded: {
    id: 'frontbucket.pipelines.components.warningMessage.timeLimitExceeded',
    description: 'Text for time limit exceeded',
    defaultMessage:
      'The build stopped because one or more steps reached the timeout limit of two hours.',
  },
  parseError: {
    id: 'frontbucket.pipelines.components.warningMessage.parseError',
    description:
      'Text for parse error. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'Something is misconfigured in your <bold>{ymlFileName}</bold> file. View it in our editor to find out where.',
  },
  parseIndentationError: {
    id: 'frontbucket.pipelines.components.warningMessage.parseIndentationError',
    description:
      'Text for parse indentation error. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'The indentation in the <bold>{ymlFileName}</bold> file is incorrect. Correct the spacing and remove any tabs.',
  },
  invalidImageName: {
    id: 'frontbucket.pipelines.components.warningMessage.invalidImageName',
    description:
      'Text for invalid image name. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      "We don''t recognise the image name {element} in your <bold>{ymlFileName}</bold> file. Correct the name to get this working.",
  },
  tooManySteps: {
    id: 'frontbucket.pipelines.components.warningMessage.tooManySteps',
    description:
      'Text for too many steps. The "A pipeline cannot exceed 100 steps" link text is wrapped in <link> tags.',
    defaultMessage:
      '<link>A pipeline cannot exceed 100 steps</link>. To run this pipeline, reduce the total number of steps',
  },
  checkDocumentationText: {
    id: 'frontbucket.pipelines.components.warningMessage.checkDocumentationText',
    description: 'Text for check documentation',
    defaultMessage:
      'Check out our documentation on how to format the {element} section.',
  },
  invalidList: {
    id: 'frontbucket.pipelines.components.warningMessage.invalidList',
    description:
      'Text for invalid list. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'The {element} section in your <bold>{ymlFileName}</bold> file must be a list.',
  },
  invalidMap: {
    id: 'frontbucket.pipelines.components.warningMessage.invalidMap',
    description:
      'Text for invalid map. The yml file name is wrapped in <bold> tags so it can be visually emphasised.',
    defaultMessage:
      'The {element} section in your <bold>{ymlFileName}</bold> file must be a map.',
  },
  troubleshootingRunners: {
    id: 'warning.troubleshootingRunners',
    defaultMessage: `Refer to the Troubleshooting runners document for help resolving the issue.`,
  },
  actionRequired: {
    id: 'frontbucket.pipelines.components.warningMessage.actionRequired',
    description: 'Text for action required',
    defaultMessage:
      'This pipeline was halted because a step needs input to resume on a child pipeline. Resume the child pipeline for this pipeline to proceed.',
  },
});
